// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bhs_a bii_ea bii_a","LoadingSwitch__init":"bhs_b bii_a bii_w bii_j bii_ul bii_um bii_fm"};